module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"mic":"Микрофон","camera":"Камера","settings":"Настройки"}}')
  delete Component.options._Ctor
}
